import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


// 公共路由
export const constantRoutes = [
  {
    path: '/index',
    name: 'homepage',
    component: () => import('@/views/homePage/indexOld'),
  },
      {
        path: '/',
        name: 'homepage',
        component: () => import('@/views/homePage/indexOld'),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/index'),
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product/index'),
      },
      {
        path: '/product0703',
        name: 'product0703',
        component: () => import('@/views/product/product0703.vue'),
      },
      {
        path: '/product0703V2',
        name: 'product0703V2',
        component: () => import('@/views/product/product0703V2.vue'),
      },
      {
        path: '/product/detail',
        name: 'productDetail',
        component: () => import('@/views/product/detail.vue'),
      },
      {
        path: '/projectCase',
        name: 'projectCase',
        component: () => import('@/views/anli/index.vue'),
      },
      {
        path: '/news',
        name: 'news',
        component: () => import('@/views/news/index.vue'),
      },
      {
        path: '/news/detail',
        name: 'newsDetail',
        component: () => import('@/views/news/detail.vue'),
      },
      {
        path: '/joinus',
        name: 'joinus',
        component: () => import('@/views/jiameng/index.vue'),
      },
      {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import('@/views/contactUs/index.vue'),
      },
      {
        path: '/index0701',
        name: 'index0701',
        component: () => import('@/views/homePage/index0701.vue'),
      },
      {
        path: '/index0701V2',
        name: 'index0701V2',
        component: () => import('@/views/homePage/index0701V2.vue'),
      },
      {
        path: '/vidio1',
        name: 'vidio1',
        component: () => import('@/views/vidio/vidio1.vue'),
      },
      {
        path: '/vidio2',
        name: 'vidio2',
        component: () => import('@/views/vidio/vidio2.vue'),
      },
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
